import type { Timesheets } from '../types/timesheet';
import { DateTime } from 'luxon';

const timesheets: Timesheets = [
  {
    Id: 0,
    Employee: 1,
    Date: '2022-08-04T00:00:00+10:00',
    StartTime: 1659567900,
    EndTime: 1659596700,
    Mealbreak: '2022-08-04T00:30:00+10:00',
    MealbreakSlots: '',
    Slots: [],
    TotalTime: 7.5,
    Roster: null,
    EmployeeComment:
      'Had to clock off a little late as it got busy before close.',
    OperationalUnit: 1,
    IsInProgress: true,
    IsLeave: false,
    CustomFieldData: null,
    OnCost: 0,
    StartTimeLocalized: DateTime.now().toISO(),
    EndTimeLocalized: '2022-08-04T17:05:00+10:00',
  },
  {
    Id: 1,
    Employee: 1,
    Date: '2022-08-04T00:00:00+10:00',
    StartTime: 1659567900,
    EndTime: 1659596700,
    Mealbreak: '2022-08-04T00:30:00+10:00',
    MealbreakSlots: '',
    Slots: [
      {
        blnEmptySlot: false,
        intEnd: 120,
        intStart: 0,
        intUnixEnd: 1660707780,
        intUnixStart: 1660707660,
        mixedActivity: {
          intState: 1,
          blnCanStartEarly: 1,
          blnCanEndEarly: 1,
          blnIsMandatory: 2,
          strBreakType: 'R',
        },
        strState: 'In Progress',
        strType: 'B',
        strTypeName: 'Rest Break',
      },
      {
        blnEmptySlot: false,
        intEnd: null,
        intStart: 120,
        intUnixEnd: null,
        intUnixStart: DateTime.now().toSeconds(),
        mixedActivity: {
          intState: 1,
          blnCanStartEarly: 1,
          blnCanEndEarly: 1,
          blnIsMandatory: 1,
          strBreakType: 'M',
        },
        strState: 'In Progress',
        strType: 'B',
        strTypeName: 'Meal Break',
      },
    ],
    TotalTime: 7.5,
    Roster: null,
    EmployeeComment:
      'Had to clock off a little late as it got busy before close.',
    OperationalUnit: 1,
    IsInProgress: true,
    IsLeave: false,
    CustomFieldData: null,
    OnCost: 0,
    StartTimeLocalized: DateTime.fromMillis(
      DateTime.now().toMillis() - 10 * 60000
    ).toISO(),
    EndTimeLocalized: '2022-08-04T17:05:00+10:00',
  },
  {
    Id: 2,
    Employee: 1,
    Date: '2022-08-04T00:00:00+10:00',
    StartTime: 1659567900,
    EndTime: 1659596700,
    Mealbreak: '2022-08-04T00:30:00+10:00',
    MealbreakSlots: '',
    Slots: [
      {
        blnEmptySlot: false,
        intEnd: 120,
        intStart: 0,
        intUnixEnd: 1660707780,
        intUnixStart: 1660707660,
        mixedActivity: {
          intState: 1,
          blnCanStartEarly: 1,
          blnCanEndEarly: 1,
          blnIsMandatory: 2,
          strBreakType: 'R',
        },
        strState: 'Finished',
        strType: 'B',
        strTypeName: 'Rest Break',
      },
      {
        blnEmptySlot: false,
        intEnd: null,
        intStart: 120,
        intUnixEnd: 1660193700,
        intUnixStart: 1660193580,
        mixedActivity: {
          intState: 1,
          blnCanStartEarly: 1,
          blnCanEndEarly: 1,
          blnIsMandatory: 1,
          strBreakType: 'M',
        },
        strState: 'Finished',
        strType: 'B',
        strTypeName: 'Meal Break',
      },
    ],
    TotalTime: 7.5,
    Roster: 1,
    EmployeeComment:
      'Had to clock off a little late as it got busy before close.',
    OperationalUnit: 1,
    IsInProgress: true,
    IsLeave: false,
    CustomFieldData: null,
    OnCost: 0,
    StartTimeLocalized: DateTime.fromMillis(
      DateTime.now().toMillis() - 20 * 60000
    ).toISO(),
    EndTimeLocalized: '2022-08-04T17:05:00+10:00',
  },
  {
    Id: 3,
    Employee: 1,
    Date: '2022-08-04T00:00:00+10:00',
    StartTime: 1659567900,
    EndTime: 1659596700,
    Mealbreak: '2022-08-04T00:30:00+10:00',
    MealbreakSlots: '',
    Slots: [
      {
        blnEmptySlot: false,
        intEnd: 120,
        intStart: 0,
        intUnixEnd: 1660707780,
        intUnixStart: 1660707660,
        mixedActivity: {
          intState: 1,
          blnCanStartEarly: 1,
          blnCanEndEarly: 1,
          blnIsMandatory: 2,
          strBreakType: 'R',
        },
        strState: 'Finished',
        strType: 'B',
        strTypeName: 'Rest Break',
      },
      {
        blnEmptySlot: false,
        intEnd: null,
        intStart: 120,
        intUnixEnd: null,
        intUnixStart: 1660193580,
        mixedActivity: {
          intState: 1,
          blnCanStartEarly: 1,
          blnCanEndEarly: 1,
          blnIsMandatory: 1,
          strBreakType: 'M',
        },
        strState: 'Finished',
        strType: 'B',
        strTypeName: 'Meal Break',
      },
    ],
    TotalTime: 7.5,
    Roster: null,
    EmployeeComment:
      'Had to clock off a little late as it got busy before close.',
    OperationalUnit: 1,
    IsInProgress: false,
    IsLeave: false,
    CustomFieldData: null,
    OnCost: 0,
    StartTimeLocalized: DateTime.fromMillis(
      DateTime.now().toMillis() - 1 * 60000
    ).toISO(),
    EndTimeLocalized: '2022-08-04T17:05:00+10:00',
  },
  {
    Id: 4,
    Employee: 1,
    Date: '2022-08-04T00:00:00+10:00',
    StartTime: 1659567900,
    EndTime: 1659596700,
    Mealbreak: '2022-08-04T00:30:00+10:00',
    MealbreakSlots: '',
    Slots: [],
    TotalTime: 7.5,
    Roster: null,
    EmployeeComment:
      'Had to clock off a little late as it got busy before close.',
    OperationalUnit: 1,
    IsInProgress: true,
    IsLeave: false,
    CustomFieldData: null,
    OnCost: 0,
    StartTimeLocalized: '2022-08-04T09:05:00+10:00',
    EndTimeLocalized: '2022-08-04T17:05:00+10:00',
  },
  {
    Id: 5,
    Employee: 1,
    Date: '2022-08-04T00:00:00+10:00',
    StartTime: 1659567900,
    EndTime: 1659596700,
    Mealbreak: '2022-08-04T00:30:00+10:00',
    MealbreakSlots: '',
    Slots: [
      {
        blnEmptySlot: false,
        intEnd: 120,
        intStart: 0,
        intUnixEnd: 1660707780,
        intUnixStart: 1660707660,
        mixedActivity: {
          intState: 1,
          blnCanStartEarly: 1,
          blnCanEndEarly: 1,
          blnIsMandatory: 2,
          strBreakType: 'R',
        },
        strState: 'Finished',
        strType: 'B',
        strTypeName: 'Rest Break',
      },
      {
        blnEmptySlot: false,
        intEnd: null,
        intStart: 120,
        intUnixEnd: null,
        intUnixStart: 1660193580,
        mixedActivity: {
          intState: 1,
          blnCanStartEarly: 1,
          blnCanEndEarly: 1,
          blnIsMandatory: 1,
          strBreakType: 'R',
        },
        strState: 'In Progress',
        strType: 'B',
        strTypeName: 'Rest Break',
      },
    ],
    TotalTime: 7.5,
    Roster: null,
    EmployeeComment:
      'Had to clock off a little late as it got busy before close.',
    OperationalUnit: 1,
    IsInProgress: true,
    IsLeave: false,
    CustomFieldData: null,
    OnCost: 0,
    StartTimeLocalized: DateTime.fromMillis(
      DateTime.now().toMillis() - 20 * 60000
    ).toISO(),
    EndTimeLocalized: '2022-08-04T17:05:00+10:00',
  },
  {
    Id: 6,
    Employee: 2,
    Date: '2022-08-04T00:00:00+10:00',
    StartTime: 1659567900,
    EndTime: 1659596700,
    Mealbreak: '2022-08-04T00:30:00+10:00',
    MealbreakSlots: '',
    Slots: [
      {
        blnEmptySlot: false,
        intEnd: 120,
        intStart: 0,
        intUnixEnd: 1660707780,
        intUnixStart: 1660707660,
        mixedActivity: {
          intState: 1,
          blnCanStartEarly: 1,
          blnCanEndEarly: 1,
          blnIsMandatory: 2,
          strBreakType: 'R',
        },
        strState: 'Finished',
        strType: 'B',
        strTypeName: 'Rest Break',
      },
    ],
    TotalTime: 7.5,
    Roster: null,
    EmployeeComment:
      'Had to clock off a little late as it got busy before close.',
    OperationalUnit: 1,
    IsInProgress: true,
    IsLeave: false,
    CustomFieldData: null,
    OnCost: 0,
    StartTimeLocalized: DateTime.fromMillis(
      DateTime.now().toMillis() - 20 * 60000
    ).toISO(),
    EndTimeLocalized: '2022-08-04T17:05:00+10:00',
  },
  {
    Id: 7,
    Employee: 5,
    Date: '2022-08-04T00:00:00+10:00',
    StartTime: 1659567900,
    EndTime: 1659596700,
    Mealbreak: '2022-08-04T00:30:00+10:00',
    MealbreakSlots: '',
    Slots: [
      {
        blnEmptySlot: false,
        intEnd: 120,
        intStart: 0,
        intUnixEnd: 1660707780,
        intUnixStart: 1660707660,
        mixedActivity: {
          intState: 1,
          blnCanStartEarly: 1,
          blnCanEndEarly: 1,
          blnIsMandatory: 2,
          strBreakType: 'R',
        },
        strState: 'Finished',
        strType: 'B',
        strTypeName: 'Rest Break',
      },
      {
        blnEmptySlot: false,
        intEnd: null,
        intStart: 120,
        intUnixEnd: null,
        intUnixStart: 1660193580,
        mixedActivity: {
          intState: 1,
          blnCanStartEarly: 1,
          blnCanEndEarly: 1,
          blnIsMandatory: 1,
          strBreakType: 'R',
        },
        strState: 'In Progress',
        strType: 'B',
        strTypeName: 'Rest Break',
      },
    ],
    TotalTime: 7.5,
    Roster: null,
    EmployeeComment:
      'Had to clock off a little late as it got busy before close.',
    OperationalUnit: 1,
    IsInProgress: true,
    IsLeave: false,
    CustomFieldData: null,
    OnCost: 0,
    StartTimeLocalized: DateTime.fromMillis(
      DateTime.now().toMillis() - 20 * 60000
    ).toISO(),
    EndTimeLocalized: '2022-08-04T17:05:00+10:00',
  },
  {
    Id: 8,
    Employee: 8,
    Date: '2022-08-04T00:00:00+10:00',
    StartTime: DateTime.now().minus({ hours: 1 }).toSeconds(),
    EndTime: DateTime.now().minus({ hours: 1 }).toSeconds(),
    Mealbreak: '2022-08-04T00:30:00+10:00',
    MealbreakSlots: '',
    Slots: [
      {
        blnEmptySlot: false,
        intEnd: null,
        intStart: 120,
        intUnixEnd: DateTime.now().minus({ minutes: 1 }).toSeconds(),
        intUnixStart: 1660193580,
        mixedActivity: {
          intState: 1,
          blnCanStartEarly: 1,
          blnCanEndEarly: 1,
          blnIsMandatory: 1,
          strBreakType: 'R',
        },
        strState: 'In Progress',
        strType: 'B',
        strTypeName: 'Rest Break',
      },
    ],
    TotalTime: 7.5,
    Roster: null,
    EmployeeComment:
      'Had to clock off a little late as it got busy before close.',
    OperationalUnit: 1,
    IsInProgress: true,
    IsLeave: false,
    CustomFieldData: null,
    OnCost: 0,
    StartTimeLocalized: DateTime.fromMillis(
      DateTime.now().minus({ hours: 1 }).toMillis() - 20 * 60000
    ).toISO(),
    EndTimeLocalized: '2022-08-04T17:05:00+10:00',
  },
  {
    Id: 9,
    Employee: 13,
    Date: '2022-08-04T00:00:00+10:00',
    StartTime: DateTime.now().minus({ hours: 1 }).toSeconds(),
    EndTime: DateTime.now().plus({ hours: 2 }).toSeconds(),
    Mealbreak: '2022-08-04T00:30:00+10:00',
    MealbreakSlots: '',
    Slots: [
      {
        blnEmptySlot: false,
        intEnd: null,
        intStart: 120,
        intUnixEnd: null,
        intUnixStart: 1660193580,
        mixedActivity: {
          intState: 1,
          blnCanStartEarly: 1,
          blnCanEndEarly: 1,
          blnIsMandatory: 1,
          strBreakType: 'R',
        },
        strState: 'In Progress',
        strType: 'B',
        strTypeName: 'Rest Break',
      },
    ],
    TotalTime: 4,
    Roster: null,
    EmployeeComment: '',
    OperationalUnit: 1,
    IsInProgress: true,
    IsLeave: false,
    CustomFieldData: null,
    OnCost: 0,
    StartTimeLocalized: DateTime.fromMillis(
      DateTime.now().minus({ hours: 1 }).toMillis() - 20 * 60000
    ).toISO(),
    EndTimeLocalized: '2022-08-04T17:05:00+10:00',
  },
  {
    Id: 10,
    Employee: 14,
    Date: '2022-08-04T00:00:00+10:00',
    StartTime: 1659621720,
    EndTime: 1659596700,
    Mealbreak: '2022-08-04T00:30:00+10:00',
    MealbreakSlots: '',
    Slots: [],
    TotalTime: 7.5,
    Roster: 1,
    EmployeeComment: '',
    OperationalUnit: 1,
    IsInProgress: true,
    IsLeave: false,
    CustomFieldData: null,
    OnCost: 0,
    StartTimeLocalized: '2022-08-04T14:02:00+10:00',
    EndTimeLocalized: '2022-08-04T17:05:00+10:00',
  },
  {
    Id: 11,
    Employee: 15,
    Date: '2022-08-04T00:00:00+10:00',
    StartTime: 1659612960,
    EndTime: 1659616560,
    Mealbreak: '2022-08-04T00:30:00+10:00',
    MealbreakSlots: '',
    Slots: [
      {
        blnEmptySlot: false,
        intEnd: null,
        intStart: 120,
        intUnixEnd: DateTime.now().plus({ minutes: 34 }).toSeconds(),
        intUnixStart: DateTime.now().plus({ minutes: 4 }).toSeconds(),
        mixedActivity: {
          intState: 1,
          blnCanStartEarly: 1,
          blnCanEndEarly: 1,
          blnIsMandatory: 1,
          strBreakType: 'R',
        },
        strState: 'Not Start',
        strType: 'B',
        strTypeName: 'Rest Break',
      },
    ],
    TotalTime: 7.5,
    Roster: null,
    EmployeeComment: '',
    OperationalUnit: 1,
    IsInProgress: true,
    IsLeave: false,
    CustomFieldData: null,
    OnCost: 0,
    StartTimeLocalized: '2022-08-04T11:36:00+10:00',
    EndTimeLocalized: '2022-08-04T12:36:00+10:00',
  },
  {
    Id: 12,
    Employee: 16,
    Date: '2022-08-04T00:00:00+10:00',
    StartTime: DateTime.now().minus({ hours: 3 }).toSeconds(),
    EndTime: DateTime.now().minus({ minutes: 10 }).toSeconds(),
    Mealbreak: '2022-08-04T00:30:00+10:00',
    MealbreakSlots: '',
    Slots: [],
    TotalTime: 7.5,
    Roster: 1,
    EmployeeComment: '',
    OperationalUnit: 1,
    IsInProgress: true,
    IsLeave: false,
    CustomFieldData: null,
    OnCost: 0,
    StartTimeLocalized: '2022-08-04T11:36:00+10:00',
    EndTimeLocalized: '2022-08-04T12:36:00+10:00',
  },
  {
    Id: 13,
    Employee: 17,
    Date: '2022-08-04T00:00:00+10:00',
    StartTime: DateTime.now().minus({ hours: 3 }).toSeconds(),
    EndTime: DateTime.now().plus({ minutes: 6 }).toSeconds(),
    Mealbreak: '2022-08-04T00:30:00+10:00',
    MealbreakSlots: '',
    Slots: [],
    TotalTime: 7.5,
    Roster: 1,
    EmployeeComment: '',
    OperationalUnit: 1,
    IsInProgress: true,
    IsLeave: false,
    CustomFieldData: null,
    OnCost: 0,
    StartTimeLocalized: '2022-08-04T11:36:00+10:00',
    EndTimeLocalized: '2022-08-04T12:36:00+10:00',
  },
  {
    Id: 14,
    Employee: 18,
    Date: '2022-08-04T00:00:00+10:00',
    StartTime: DateTime.now().minus({ hours: 2 }).toSeconds(),
    EndTime: DateTime.now().plus({ hours: 3 }).toSeconds(),
    Mealbreak: '2022-08-04T00:30:00+10:00',
    MealbreakSlots: '',
    Slots: [
      {
        blnEmptySlot: false,
        intEnd: null,
        intStart: 120,
        intUnixEnd: DateTime.now().plus({ minutes: 4 }).toSeconds(),
        intUnixStart: DateTime.now().minus({ minutes: 25 }).toSeconds(),
        mixedActivity: {
          intState: 1,
          blnCanStartEarly: 1,
          blnCanEndEarly: 1,
          blnIsMandatory: 1,
          strBreakType: 'R',
        },
        strState: 'In Progress',
        strType: 'B',
        strTypeName: 'Rest Break',
      },
    ],
    TotalTime: 4,
    Roster: null,
    EmployeeComment: '',
    OperationalUnit: 1,
    IsInProgress: true,
    IsLeave: false,
    CustomFieldData: null,
    OnCost: 0,
    StartTimeLocalized: DateTime.fromMillis(
      DateTime.now().minus({ hours: 1 }).toMillis() - 20 * 60000
    ).toISO(),
    EndTimeLocalized: '2022-08-04T17:05:00+10:00',
  },
  {
    Id: 15,
    Employee: 19,
    Date: '2022-08-04T00:00:00+10:00',
    StartTime: 1659567900,
    EndTime: 1659596700,
    Mealbreak: '2022-08-04T00:30:00+10:00',
    MealbreakSlots: '',
    Slots: [
      {
        blnEmptySlot: false,
        intEnd: 120,
        intStart: 0,
        intUnixEnd: 1660707780,
        intUnixStart: 1660707660,
        mixedActivity: {
          intState: 1,
          blnCanStartEarly: 1,
          blnCanEndEarly: 1,
          blnIsMandatory: 2,
          strBreakType: 'R',
        },
        strState: 'Finished',
        strType: 'B',
        strTypeName: 'Rest Break',
      },
    ],
    TotalTime: 7.5,
    Roster: null,
    EmployeeComment:
      'Had to clock off a little late as it got busy before close.',
    OperationalUnit: 1,
    IsInProgress: true,
    IsLeave: false,
    CustomFieldData: null,
    OnCost: 0,
    StartTimeLocalized: DateTime.fromMillis(
      DateTime.now().toMillis() - 20 * 60000
    ).toISO(),
    EndTimeLocalized: '2022-08-04T17:05:00+10:00',
  },
  {
    Id: 16,
    Employee: 19,
    Date: '2022-08-04T00:00:00+10:00',
    StartTime: 1659567900,
    EndTime: 1659596700,
    Mealbreak: '2022-08-04T00:30:00+10:00',
    MealbreakSlots: '',
    Slots: [],
    TotalTime: 7.5,
    Roster: null,
    EmployeeComment:
      'Had to clock off a little late as it got busy before close.',
    OperationalUnit: 1,
    IsInProgress: false,
    IsLeave: false,
    CustomFieldData: null,
    OnCost: 0,
    StartTimeLocalized: DateTime.now().toISO(),
    EndTimeLocalized: '2022-08-04T17:05:00+10:00',
  },
  {
    Id: 17,
    Employee: 19,
    Date: '2022-08-04T00:00:00+10:00',
    StartTime: DateTime.now().minus({ hours: 2 }).toSeconds(),
    EndTime: DateTime.now().plus({ hours: 3 }).toSeconds(),
    Mealbreak: '2022-08-04T00:30:00+10:00',
    MealbreakSlots: '',
    Slots: [
      {
        blnEmptySlot: false,
        intEnd: null,
        intStart: 120,
        intUnixEnd: DateTime.now().minus({ minutes: 4 }).toSeconds(),
        intUnixStart: DateTime.now().minus({ minutes: 25 }).toSeconds(),
        mixedActivity: {
          intState: 1,
          blnCanStartEarly: 1,
          blnCanEndEarly: 1,
          blnIsMandatory: 1,
          strBreakType: 'R',
        },
        strState: 'In Progress',
        strType: 'B',
        strTypeName: 'Rest Break',
      },
    ],
    TotalTime: 4,
    Roster: null,
    EmployeeComment: '',
    OperationalUnit: 1,
    IsInProgress: true,
    IsLeave: false,
    CustomFieldData: null,
    OnCost: 0,
    StartTimeLocalized: DateTime.fromMillis(
      DateTime.now().minus({ hours: 1 }).toMillis() - 20 * 60000
    ).toISO(),
    EndTimeLocalized: '2022-08-04T17:05:00+10:00',
  },
  {
    Id: 18,
    Employee: 19,
    Date: '2022-08-04T00:00:00+10:00',
    StartTime: 1659567900,
    EndTime: 1659596700,
    Mealbreak: '2022-08-04T00:30:00+10:00',
    MealbreakSlots: '',
    Slots: [],
    TotalTime: 7.5,
    Roster: null,
    EmployeeComment:
      'Had to clock off a little late as it got busy before close.',
    OperationalUnit: 1,
    IsInProgress: true,
    IsLeave: false,
    CustomFieldData: null,
    OnCost: 0,
    StartTimeLocalized: DateTime.now().minus({ minutes: 50 }).toISO(),
    EndTimeLocalized: '2022-08-04T17:05:00+10:00',
  },
  {
    Id: 19,
    Employee: 4,
    Date: '2022-08-04T00:00:00+10:00',
    StartTime: 1659567900,
    EndTime: 1659596700,
    Mealbreak: '2022-08-04T00:30:00+10:00',
    MealbreakSlots: '',
    Slots: [],
    TotalTime: 7.5,
    Roster: null,
    EmployeeComment:
      'Had to clock off a little late as it got busy before close.',
    OperationalUnit: 1,
    IsInProgress: false,
    IsLeave: false,
    CustomFieldData: null,
    OnCost: 0,
    StartTimeLocalized: DateTime.fromMillis(
      DateTime.now().toMillis() - 1 * 60000
    ).toISO(),
    EndTimeLocalized: '2022-08-04T17:05:00+10:00',
  },
  {
    Id: 20,
    Employee: 20,
    Date: '2022-08-04T00:00:00+10:00',
    StartTime: DateTime.now().minus({ hours: 2 }).toSeconds(),
    EndTime: DateTime.now().plus({ hours: 3 }).toSeconds(),
    Mealbreak: '2022-08-04T00:30:00+10:00',
    MealbreakSlots: '',
    Slots: [
      {
        blnEmptySlot: false,
        intEnd: null,
        intStart: 120,
        intUnixEnd: DateTime.now().plus({ minutes: 34 }).toSeconds(),
        intUnixStart: DateTime.now().minus({ minutes: 3 }).toSeconds(),
        mixedActivity: {
          intState: 1,
          blnCanStartEarly: 1,
          blnCanEndEarly: 1,
          blnIsMandatory: 1,
          strBreakType: 'R',
        },
        strState: 'Not Start',
        strType: 'B',
        strTypeName: 'Rest Break',
      },
    ],
    TotalTime: 7.5,
    Roster: 1,
    EmployeeComment:
      'Had to clock off a little late as it got busy before close.',
    OperationalUnit: 1,
    IsInProgress: true,
    IsLeave: false,
    CustomFieldData: null,
    OnCost: 0,
    StartTimeLocalized: DateTime.fromMillis(
      DateTime.now().toMillis() - 1 * 60000
    ).toISO(),
    EndTimeLocalized: '2022-08-04T17:05:00+10:00',
  },
  {
    Id: 21,
    Employee: 1,
    Date: '2022-08-04T00:00:00+10:00',
    StartTime: DateTime.now().minus({ hours: 2 }).toSeconds(),
    EndTime: DateTime.now().plus({ hours: 3 }).toSeconds(),
    Mealbreak: '2022-08-04T00:30:00+10:00',
    MealbreakSlots: '',
    Slots: [
      {
        blnEmptySlot: false,
        intEnd: null,
        intStart: 120,
        intUnixEnd: DateTime.now().plus({ minutes: 34 }).toSeconds(),
        intUnixStart: DateTime.now().minus({ minutes: 3 }).toSeconds(),
        mixedActivity: {
          intState: 1,
          blnCanStartEarly: 1,
          blnCanEndEarly: 1,
          blnIsMandatory: 1,
          strBreakType: 'M',
        },
        strState: 'Not Start',
        strType: 'B',
        strTypeName: 'Meal Break',
      },
    ],
    TotalTime: 7.5,
    Roster: 1,
    EmployeeComment:
      'Had to clock off a little late as it got busy before close.',
    OperationalUnit: 1,
    IsInProgress: true,
    IsLeave: false,
    CustomFieldData: null,
    OnCost: 0,
    StartTimeLocalized: DateTime.fromMillis(
      DateTime.now().toMillis() - 1 * 60000
    ).toISO(),
    EndTimeLocalized: '2022-08-04T17:05:00+10:00',
  },
  {
    Id: 22,
    Employee: 1,
    Date: '2022-08-04T00:00:00+10:00',
    StartTime: DateTime.now().minus({ hours: 2 }).toSeconds(),
    EndTime: DateTime.now().plus({ hours: 3 }).toSeconds(),
    Mealbreak: '2022-08-04T00:30:00+10:00',
    MealbreakSlots: '',
    Slots: [
      {
        blnEmptySlot: false,
        intEnd: null,
        intStart: 120,
        intUnixEnd: DateTime.now().plus({ minutes: 34 }).toSeconds(),
        intUnixStart: DateTime.now().minus({ minutes: 3 }).toSeconds(),
        mixedActivity: {
          intState: 1,
          blnCanStartEarly: 1,
          blnCanEndEarly: 1,
          blnIsMandatory: 1,
          strBreakType: 'R',
        },
        strState: 'Not Start',
        strType: 'B',
        strTypeName: 'Rest Break',
      },
      {
        blnEmptySlot: false,
        intEnd: null,
        intStart: 120,
        intUnixEnd: DateTime.now().plus({ minutes: 34 }).toSeconds(),
        intUnixStart: DateTime.now().minus({ minutes: 3 }).toSeconds(),
        mixedActivity: {
          intState: 1,
          blnCanStartEarly: 1,
          blnCanEndEarly: 1,
          blnIsMandatory: 1,
          strBreakType: 'M',
        },
        strState: 'Not Start',
        strType: 'B',
        strTypeName: 'Meal Break',
      },
    ],
    TotalTime: 7.5,
    Roster: 1,
    EmployeeComment:
      'Had to clock off a little late as it got busy before close.',
    OperationalUnit: 1,
    IsInProgress: true,
    IsLeave: false,
    CustomFieldData: null,
    OnCost: 0,
    StartTimeLocalized: DateTime.fromMillis(
      DateTime.now().toMillis() - 1 * 60000
    ).toISO(),
    EndTimeLocalized: '2022-08-04T17:05:00+10:00',
  },
];

export function getTimesheetsMock() {
  return timesheets;
}

export function getTimesheetsMockByEmployeeId(id: number) {
  return timesheets.filter((timesheet) => timesheet.Employee === id);
}
